import React from "react";

import { SelectedTasksBar } from "src/app/components/SelectedTasksBar/SelectedTasksBar";

export default function SelectedCreatorsBar({
  selectedCreatorsLength,
  children,
}) {
  return (
    <SelectedTasksBar
      selectedTasksLength={selectedCreatorsLength}
      showBottomOverlay
    >
      {children}
    </SelectedTasksBar>
  );
}
